import { useQueries } from '@tanstack/react-query';
import api from '../lib/api';

export const useCompanyDashboard = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['companyStatistics'],
                queryFn: () => api.get('/company/statistics').then(res => res.data.data),
                staleTime: 1000 * 60 * 5,
            },
            {
                queryKey: ['companyQuotesSummary'],
                queryFn: () => api.get('/company/quotes-summary').then(res => res.data.data),
                staleTime: 1000 * 60 * 5,
            },
            {
                queryKey: ['companyInvoicesSummary'],
                queryFn: () => api.get('/company/invoices-summary').then(res => res.data.data),
                staleTime: 1000 * 60 * 5,
            },
        ],
    });

    const [statisticsQuery, quotesSummaryQuery, invoicesSummaryQuery] = queries;

    const statistics = statisticsQuery.data || {
        total_offers_submitted: 0,
        accepted_offers_count: 0,
        total_jobs_count: 0,
        net_profit: 0,
        net_profit_formatted: "0.00",
        profit_breakdown: [],
    };

    const quotesSummary = quotesSummaryQuery.data || {
        quotes_accepted_today: { count: 0, total_amount: 0, formatted_amount: "0.00" },
        quotes_with_completed_jobs: { count: 0, total_amount: 0, formatted_amount: "0.00", details: [] },
        quotes_remaining: { count: 0, total_amount: 0, formatted_amount: "0.00", details: [] },
    };

    const invoicesSummary = invoicesSummaryQuery.data || {
        recent_invoices: [],
        total_invoices_count: 0,
        total_profit: 0,
        formatted_total_profit: "0.00",
    };

    const isLoading = queries.some(query => query.isLoading);
    const isError = queries.some(query => query.isError);
    const error = queries.find(query => query.isError)?.error || null;

    const refetchAll = () => {
        queries.forEach(query => query.refetch());
    };

    return {
        statistics,
        quotesSummary,
        invoicesSummary,

        isLoading,
        isError,
        error,

        refetchAll,

        statisticsQuery,
        quotesSummaryQuery,
        invoicesSummaryQuery,
    };
};